import React from "react";
import styled from "styled-components";
import { SeparateLine } from "styles/elements/main";
import { AccordionComponent } from "components";
import ViewPaymentInfo from "modules/shared/profiles/ViewPaymentInfo";
import SectionsData from "modules/shared/profiles/SectionsData";
import ViewPersonalIfon from "./ViewPersonalIfon";
import ViewWorkingInfo from "./ViewWorkingInfo";

function ProfileData({ data }) {
    return (
        <Container>
            <AccordionComponent
                id={data?.id}
                title="Personal Info"
                defaultExpanded
                body={<ViewPersonalIfon data={data?.attributes} />}
            />
            <SeparateLine />
            <AccordionComponent
                defaultExpanded
                id={data?.id}
                title="Working Info"
                body={<ViewWorkingInfo data={data} />}
            />
            <SeparateLine />
            <AccordionComponent
                defaultExpanded
                id={data?.id}
                title="Payments Info"
                body={<ViewPaymentInfo data={data?.paymentMethod} />}
            />
            <SeparateLine />
            <AccordionComponent
                defaultExpanded
                id={data?.id}
                title="Others"
                body={
                    <SectionsData
                        label="Notes"
                        text={data?.attributes?.notes}
                    />
                }
            />
        </Container>
    );
}
const Container = styled.div`
    max-width: 85%;
    padding: 30px;
    margin-block: 30px;
    background: #ffffff;
    box-shadow: 0px 0px 3px #00000024;
    border-radius: 5px;
    border: 1px solid #00000024;
    display: flex;
    flex-direction: column;
`;
export default ProfileData;
